import React from "react";
import PropTypes from "prop-types";

export const Arrow = ({ color = "#333" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M9.84164 10.9213L13.8745 14.9542L12.9507 15.8781L7.99396 10.9213L12.9507 5.96463L13.8745 6.88846L9.84164 10.9213Z"
        fill={color}
      />
    </svg>
  );
};

Arrow.propTypes = {
  color: PropTypes.string,
};
